import React, { useEffect, useState } from "react";
import { useUsers } from "../../hooks/useUsers";
import { useDeleteOrganisationMember } from "../../hooks/useOrganisations";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { snackbarUtils } from "../../utils";

const ConfirmDeleteMember = ({
  organisation_id,
  user_id,
  open,
  handleClose,
}) => {
  const { data: users } = useUsers();
  const [user, setUser] = useState(null);
  const deleteOrganisationMemberMutation = useDeleteOrganisationMember();

  const handleDelete = () => {
    deleteOrganisationMemberMutation.mutate(
      { organisationId: organisation_id, userId: user_id },
      {
        onSuccess: () => {
          snackbarUtils.updateMessage("Member deleted");
          handleClose();
        },
        onError: () => {
          snackbarUtils.updateMessage("Member delete error");
        },
      }
    );
  };

  useEffect(() => {
    if (users?.length) {
      setUser(users.filter((user) => user.id === parseInt(user_id))[0]);
    }
  }, [users, user_id]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Confirm Delete Member</DialogTitle>
      <DialogContent>
        <p>
          Are you sure you want to delete {user && user.email ? user.email : ""}
          ?
        </p>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="outlined" onClick={handleDelete} color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteMember;
